import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "document p-2" }
const _hoisted_2 = { class: "compass-doc-section p-1" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-6 d-block" }
const _hoisted_5 = {
  class: "flex align-items-center justify-content-end gap-3",
  style: {"height":"60px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "grid mt-1 pl-4" }
const _hoisted_8 = { class: "col-4 flex p-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "col-4 flex p-0" }
const _hoisted_11 = { class: "col-4 flex p-0" }
const _hoisted_12 = { class: "compass-doc-section" }
const _hoisted_13 = { class: "body" }
const _hoisted_14 = { class: "compass-doc-section" }
const _hoisted_15 = { class: "body" }
const _hoisted_16 = { class: "compass-doc-section" }
const _hoisted_17 = { class: "body" }
const _hoisted_18 = {
  key: 0,
  class: "grid"
}
const _hoisted_19 = { class: "col-6 pt-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "compass-doc-section" }
const _hoisted_23 = {
  key: 0,
  class: "body"
}
const _hoisted_24 = { class: "compass-doc-section p-2 mt-1" }
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "compass-doc-section p-2 mt-1" }
const _hoisted_30 = { class: "grid" }
const _hoisted_31 = { class: "grid" }
const _hoisted_32 = { class: "document-text-border col mr-3 pl-2" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "grid" }
const _hoisted_36 = { class: "document-text-border col mr-3 pl-2" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "grid" }
const _hoisted_40 = { class: "document-text-border col mr-3 pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-6 document-title" }, [
          _createElementVNode("p", null, "Building Warrant of Fitness"),
          _createElementVNode("p", null, "Form 12 Section 108"),
          _createElementVNode("p", null, "Building Act 2004 ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.propertyData.displayCompassLogo)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "css-image compass-logo flex-1",
                  style: _normalizeStyle({ height: _ctx.customerLogoDataUri ? '50px' : '56px', backgroundPosition: _ctx.customerLogoDataUri ? 'center' : 'right' })
                }, null, 4))
              : _createCommentVNode("", true),
            (_ctx.customerLogoDataUri)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.customerLogoDataUri,
                  style: {"height":"38px","max-width":"250px"}
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "compass-red" }, "Expires:", -1)),
        _cache[2] || (_cache[2] = _createTextVNode(" ", -1)),
        (_ctx.parentBwofService)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formattedDate(_ctx.parentBwofService.whenNextServiceAnniversary)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "compass-red" }, "Project No:", -1)),
        _cache[4] || (_cache[4] = _createTextVNode(" ", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.propertyData.propertyId), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "compass-red" }, "C.S. No:", -1)),
        _cache[6] || (_cache[6] = _createTextVNode(" ", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.bwof.complianceSchedule), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("span", null, "BUILDING DETAILS")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _cache[7] || (_cache[7] = _createElementVNode("b", null, "Building name:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.propertyData.buildingName), 1),
        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("b", null, "Street address of building:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1),
        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("b", null, "Legal description of land where building is located:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.legalDescription), 1),
        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("b", null, "Location of building within site:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.locationOfBuildingWithinSite), 1),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("b", null, "Level / Unit no:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.levelUnitNo), 1),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _cache[17] || (_cache[17] = _createElementVNode("b", null, "Current, lawfully established use:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.buildingUse), 1),
        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
        _cache[19] || (_cache[19] = _createElementVNode("b", null, "Year first constructed:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.firstConstructed), 1),
        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
        _cache[21] || (_cache[21] = _createElementVNode("b", null, "Intended life of the building if 50 years or less:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.intendedLifeOfTheBuilding), 1),
        _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
        _cache[23] || (_cache[23] = _createElementVNode("b", null, "Purpose group:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.purposeGroup), 1),
        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
        _cache[25] || (_cache[25] = _createElementVNode("b", null, "Highest fire hazard category for building use:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.highestFireHazardCategoryFhcNumber), 1),
        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
        _cache[27] || (_cache[27] = _createElementVNode("b", null, "Maximum No. of occupants:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.maximumNumberOfOccupants), 1),
        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("span", null, "OWNER DETAILS")
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _cache[30] || (_cache[30] = _createElementVNode("b", null, "Name:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.owner.companyName), 1),
        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
        _cache[32] || (_cache[32] = _createElementVNode("b", null, "Mailing address:", -1)),
        _createElementVNode("span", null, "  " + _toDisplayString(_ctx.owner.streetAddress) + "  " + _toDisplayString(_ctx.owner.postalAddress) + "  " + _toDisplayString(_ctx.owner.suburb) + "  " + _toDisplayString(_ctx.owner.city), 1),
        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
        _cache[34] || (_cache[34] = _createElementVNode("b", null, "Contact name:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.firstName) + " " + _toDisplayString(_ctx.contact.lastName), 1),
        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
        _cache[36] || (_cache[36] = _createElementVNode("b", null, "Contact phone:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.ddi), 1),
        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
        _cache[38] || (_cache[38] = _createElementVNode("b", null, "Contact mobile:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.mobile), 1),
        _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
        _cache[40] || (_cache[40] = _createElementVNode("b", null, "Contact email:", -1)),
        _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.email), 1),
        _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("span", null, "AGENT DETAILS")
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.agent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[43] || (_cache[43] = _createElementVNode("b", null, "Name of agent:", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("span", null, " Compass New Zealand Limited", -1)),
                _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                _cache[46] || (_cache[46] = _createElementVNode("b", null, "Contact person:", -1)),
                (_ctx.bwof.issuedBy == 'John')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, " John Bell"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, " Keith Flatt")),
                _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                _cache[48] || (_cache[48] = _createElementVNode("b", null, "Phone:", -1)),
                _cache[49] || (_cache[49] = _createElementVNode("span", null, " 09 477 2720", -1)),
                _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                _cache[51] || (_cache[51] = _createElementVNode("b", null, "Relationship to owner:", -1)),
                _cache[52] || (_cache[52] = _createElementVNode("span", null, " Owner authorised agent ", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1))
              ]),
              _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col6 pt-2" }, [
                _createElementVNode("b", null, "Mailing address:"),
                _createElementVNode("span", null, " PO Box 303 484 North Harbour 0751"),
                _createElementVNode("br"),
                _createElementVNode("b", null, "Email:"),
                _createElementVNode("span", null, " bwof@compassnzl.co.nz"),
                _createElementVNode("br")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _cache[56] || (_cache[56] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("span", null, "SPECIFIED SYSTEMS")
      ], -1)),
      (_ctx.propertyData.services)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bwofServices, (service) => {
              return (_openBlock(), _createElementBlock("p", {
                key: service.serviceId,
                class: "mb-0"
              }, _toDisplayString(service.serviceName), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("p", _hoisted_25, "The compliance schedule No. " + _toDisplayString(_ctx.bwof.complianceSchedule) + " and the written reports obtained in accordance with the compliance schedule are to be kept at: the premises.", 1),
      _createElementVNode("p", _hoisted_26, [
        _cache[57] || (_cache[57] = _createTextVNode("The inspection, maintenance and reporting procedures of the Compliance Schedule for the above building have been fully complied with during the ", -1)),
        (_ctx.bwof.complianceScheduleMonths == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " month", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " months", 1)),
        _cache[58] || (_cache[58] = _createTextVNode(" prior to the date stated below.", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-7 flex flex-nowrap" }, " Signature of agent on behalf of and with the authority of the owner: ", -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["document-text-border col mr-4 mt-1 css-image", [_ctx.bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Name:  ", -1)),
        _createElementVNode("div", _hoisted_32, [
          (_ctx.bwof.issuedBy == 'John')
            ? (_openBlock(), _createElementBlock("span", _hoisted_33, "John Bell"))
            : (_openBlock(), _createElementBlock("span", _hoisted_34, "Keith Flatt"))
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Position:  ", -1)),
        _createElementVNode("div", _hoisted_36, [
          (_ctx.bwof.issuedBy == 'John')
            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "General Manager (Compass New Zealand Ltd)"))
            : (_openBlock(), _createElementBlock("span", _hoisted_38, "Managing Director (Compass New Zealand Ltd)"))
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Date:  ", -1)),
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formattedDate(_ctx.bwof.bwofIssuedDate ?? new Date())), 1)
      ])
    ])
  ]))
}